import {createContext, type ReactNode, useContext} from 'react'

import {
  type BillsContextValue,
  useBills as useBillsHook,
} from '../hooks/useBills'

const BillsContext = createContext<BillsContextValue | null>(null)

export function BillsProvider({children}: {children: ReactNode}) {
  const value = useBillsHook()
  return <BillsContext.Provider value={value}>{children}</BillsContext.Provider>
}

export function useBillsContext(): BillsContextValue {
  const ctx = useContext(BillsContext)
  if (!ctx) throw new Error('useBillsContext must be used within BillsProvider')
  return ctx
}

export {BillsContext}

export const useBills = useBillsContext
